import useWindowScrollPosition from 'hooks/useWindowScrollPosition';
import { useEffect } from 'react';
import { useThrottle } from 'react-use';

const useThrottledWindowScrollPosition = ({
  callback,
  time = 100,
  isScrollTrackingDisabled = false,
}) => {
  const position = useWindowScrollPosition(isScrollTrackingDisabled);
  const { x = 0, y = 0 } = position;
  const throttledX = useThrottle(x, time);
  const throttledY = useThrottle(y, time);

  useEffect(() => {
    callback({ throttledX, throttledY });
  }, [callback, throttledX, throttledY]);
};

export default useThrottledWindowScrollPosition;
